@if (uiController === UIControlTyp.MultiSelectList) {
  <kendo-multiselect
    textField="name"
    valueField="id"
    [valuePrimitive]="true"
    [filterable]="true"
    (filterChange)="filterAcademicPartnerList($event)"
    [data]="AcademicPartnerList"
    [value]="SelectedAcademicPartnerIds"
    placeholder="Wählen Sie einen Wert aus!"
    (valueChange)="valueChanged($event)">
  </kendo-multiselect>
}
@if (uiController === UIControlTyp.DropDownList) {
  <kendo-dropdownlist
    class="fdb-kendo-dropdown"
    textField="name"
    valueField="id"
    [data]="AcademicPartnerList"
    [(ngModel)]="AcademicPartner"
    (valueChange)="valueChanged()">
  </kendo-dropdownlist>
}
@if (uiController === UIControlTyp.GridSingleValueField) {
  {{ getName() }}
}
